import { render, staticRenderFns } from "./ForgotPassEmail.vue?vue&type=template&id=09bfd97a&scoped=true&"
import script from "./ForgotPassEmail.vue?vue&type=script&lang=js&"
export * from "./ForgotPassEmail.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPassEmail.vue?vue&type=style&index=0&id=09bfd97a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bfd97a",
  null
  
)

export default component.exports